import React from 'react';

import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const LeaderboardLoading = () => {
  return (
    <Box mx={4}>
      <Skeleton width={200} height={20} />
      <Skeleton width={260} height={16} />
      <Skeleton width={220} height={16} />
      <Box height={56} display="flex" alignItems="center">
        <Skeleton width={30} height={20} />
        <Box mx={4}>
          <Skeleton variant="circle" width={40} height={40} />
        </Box>
        <Skeleton width="calc(100% - 32px - 40px - 30px)" height={20} />
      </Box>
      <Box height={56} display="flex" alignItems="center">
        <Skeleton width={30} height={20} />
        <Box mx={4}>
          <Skeleton variant="circle" width={40} height={40} />
        </Box>
        <Skeleton width="calc(100% - 32px - 40px - 30px)" height={20} />
      </Box>
    </Box>
  );
};

export default LeaderboardLoading;
